import { render, staticRenderFns } from "./ppdb.vue?vue&type=template&id=097a7ed2&scoped=true"
import script from "./ppdb.vue?vue&type=script&lang=js"
export * from "./ppdb.vue?vue&type=script&lang=js"
import style0 from "./ppdb.vue?vue&type=style&index=0&id=097a7ed2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a7ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097a7ed2')) {
      api.createRecord('097a7ed2', component.options)
    } else {
      api.reload('097a7ed2', component.options)
    }
    module.hot.accept("./ppdb.vue?vue&type=template&id=097a7ed2&scoped=true", function () {
      api.rerender('097a7ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/ppdb.vue"
export default component.exports